import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CookieSettingsModal from '../legal/CookieSettingsModal';
import './Footer.css';

interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}

interface FooterProps {
  navLinks: FooterLink[];
}

export default function Footer({ navLinks }: FooterProps) {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-brand">
          <img src="/images/foxandquill.png" alt="Fox and Quill" className="footer-fox-image" />
          <p className="footer-tagline"><em>Where tales become real.</em></p>
        </div>
        <div className="footer-right">
          <nav className="footer-links" aria-label="Footer navigation">
            {navLinks.map((link) =>
              link.to ? (
                <Link key={link.label} to={link.to}>{link.label}</Link>
              ) : (
                <a key={link.label} href={link.href}>{link.label}</a>
              )
            )}
          </nav>
          <nav className="footer-links" aria-label="Legal">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <button className="footer-link-btn" onClick={() => setShowCookieSettings(true)}>
              Cookie Settings
            </button>
          </nav>
          <div className="footer-legal">
            <p>&copy; {new Date().getFullYear()} Fox &amp; Quill. Crafted with care for young authors and their families.</p>
          </div>
        </div>
      </div>
      {showCookieSettings && <CookieSettingsModal onClose={() => setShowCookieSettings(false)} />}
    </footer>
  );
}
